/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import "bootstrap"
import { store } from "app/store.ts"
import App from "App.tsx"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import "scss/styles.scss"
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App />
  </Provider>
)
